<template>
  <div id="app" ref="main" :class="{ 'app-white': whiteBgRouter.includes($route.path) }">
    <template v-if="!wholePagePath.includes($route.path)">
      <!-- 头部  客户端模式隐藏 -->
      <home-header v-if="!isClient" style="margin-bottom: 20px"></home-header>
      <div
        class="render-payload"
        :style="{
          width: isClient ? '100%' : '',
          paddingLeft: isClient ? '20px' : '',
          paddingRight: isClient ? '20px' : ''
        }"
      >
        <!-- 面包屑 客户端模式隐藏 -->
        <g-bread-crumb v-if="!noBreadMap.includes($route.path)"></g-bread-crumb>
        <home-more
          v-if="rolePermissionList.some(obj=>obj.code=='patent_top_menu')"
        ></home-more>
        <router-view></router-view>
      </div>
    </template>
    <template v-else>
      <div class="render-payload1" :style="{ marginBottom: $route.path == '/login' ? '0' : '' }">
        <router-view></router-view>
      </div>
    </template>
    <!-- 右侧导航栏--与现有保持一致先隐藏 -->
    <!-- <menu-bar></menu-bar> -->
    <!-- 底部 公司版权和地址栏 -->
    <home-bottom v-if="hasFooterMap.includes($route.path)"></home-bottom>
    <!-- 底部全选模块 -->
    <select-all v-if="showAllSelect && ($route.path == '/patentList' || $route.path == '/patentCollect')"></select-all>
  </div>
</template>
<script>
import { mapState } from "vuex";
import HomeHeader from "./views/home/components/home-header";
import GBreadCrumb from "@/components/breadcrumb";
import HomeBottom from "./views/home/components/home-bottom";
import HomeMore from '@/views/home/components/home-more';
import SelectAll from '@/components/select-all';

export default {
  components: {
    HomeHeader,
    HomeMore,
    HomeBottom,
    GBreadCrumb,
    SelectAll
  },
  data() {
    return {
      isFromClient:
        (window.parent && window.parent[1] && window.parent[1].name == "myIframe") ||
        window.navigator.userAgent.indexOf("Electron") > -1
          ? true
          : false,
      whiteBgRouter: ["/brandInfo", "/nineGridShare"], // 背景为白色的
      wholePagePath: ["/login", "/passwordForget", "/register", "/homePage", "/brandInfo", "/websiteMaintenance", "/nineGridShare"],
      noBreadMap: ["/homePage", "/agreementDetail"],
      hasFooterMap: ["/homePage","/brandInfo"],
      manualJudgeIsClient: 0,
    };
  },
  computed: {
    ...mapState('home', {
      showAllSelect: state => state.batchShare
    }),
    ...mapState("userInfo", {
      agentType: state => state.agentType,
      partnerType: state => state.partnerType,
      payStatus: state => state.payStatus,
      interiorStatus: state => state.interiorStatus,
      accountType: state => state.accountType,
      builtinType: state => state.builtinType,
      isClient: state => state.isClient,
      rolePermissionList: state => state.rolePermissionList,
    })
  },
  watch: {
    $route(newVal) {
      this.manualJudgeIsClient = newVal.query && +newVal.query.isClient || 0;
      console.log(99);
      // this.$store.commit('userInfo/setIsClient',this.manualJudgeIsClient ? true : false);
      console.log(this.manualJudgeIsClient, this.isClient,this.partnerType);
      let main = this.$refs.main;
      main.scrollTo(0, 0);
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
#app {
  min-height: 100vh;
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f5f5f5;
  // padding-bottom: 130px;
  //min-height: 1300px;
}
.render-payload {
  margin: 0 auto 0;
  width: 1280px;
  padding-bottom: 20px;
  position: relative;
  box-sizing: border-box;
  // min-height: calc(100vh - 60px);
}
.render-payload1 {
  width: 100%;
  margin-bottom: 0px;
}
#app.app-white {
  background-color: #fff;
}
</style>
